import(/* webpackMode: "eager" */ "/codebuild/output/src1828450349/src/apps/fanychance/src/app/error.tsx");
